import React from "react";
import { motion } from "framer-motion";

const Cta = () => {

  // Container stagger
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  // Fade only (no movement)
  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className="cta-section">
      <div className="container">

        <motion.div
          className="cta-content"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          <motion.h2 className="section-heading" variants={fade}>
            Get expert guidance or request a quote today.
          </motion.h2>

          <motion.p className="section-text" variants={fade}>
    Get expert advice, quick quotes, and reliable end-to-end support to start your project with complete confidence, clarity, and ease.
          </motion.p>

          {/* BUTTON */}
          <motion.a
          href="/contact-us"
            className="btn btn-primary"
            variants={fade}
            whileHover={{ scale: 1.04 }} // subtle emphasis
            whileTap={{ scale: 0.96 }}   // firm press
            transition={{ duration: 0.2 }}
          >
            Talk to an Expert
          </motion.a>

        </motion.div>

      </div>
    </section>
  );
};

export default Cta;